import { Injectable, inject } from '@angular/core';
import { NgbTimepickerI18n } from '@ng-bootstrap/ng-bootstrap';

import { I18n } from './custom-datepicker';

const I18N_VALUES: { [id: string]: { periods: string[] } } = {
  th: { periods: ['ก่อนเที่ยง', 'หลังเที่ยง'] },
  // other languages you would support
};

/** Provides the Thai "AM"/"PM" period translations. */
@Injectable()
export class CustomTimepickerI18n extends NgbTimepickerI18n {
  private readonly i18n = inject(I18n);

  override getMorningPeriod(): string {
    return I18N_VALUES[this.i18n.language].periods[0];
  }

  override getAfternoonPeriod(): string {
    return I18N_VALUES[this.i18n.language].periods[1];
  }
}
